import { AuxiliumComponent } from "../auxilium-component";

export class List extends AuxiliumComponent {
	#showingAll = true;

	constructor() {
		super();

		this.ordered = this.hasAttribute("ordered");
		this.flush = this.hasAttribute("flush");
		this.type = this.getAttribute("type");
		this.orientation = this.getAttribute("orientation");
		this.gap = this.getAttribute("gap");
		this.initialShow = parseInt(this.getAttribute("initial-show")) || -1;
		this.clickable = this.hasAttribute("clickable");
		this.buttonPadding = this.getAttribute("button-padding");
	}

	addItem(item, list) {
		list ??= this.querySelector(":scope>ul, :scope>ol");

		if (list) {
			list.appendChild(document.createElementWithContents("li", item));
		}
	}

	getItems() {
		return [...this.querySelectorAll(":scope>chip-listitem, :scope>*>li>chip-listitem")];
	}

	toggleVisibility() {
		if (this.initialShow > -1) {
			if (!this.#showingAll) {
				this.getItems().forEach(x => x.hide = false);
			} else {
				this.getItems().forEach((item, ix) => item.hide = ix >= this.initialShow);
			}

			this.#showingAll = !this.#showingAll;
		}
	}

	removeItem(item) {
		if (item.parentElement?.nodeName === "LI") { item.parentElement.remove(); }
		else { item.remove(); }
	}

	parsedCallback() {
		const list = document.createElement(this.ordered ? "ol" : "ul");

		this.querySelectorAll(":scope > chip-listitem").forEach(item => this.addItem(item, list));

		if (this.flush) { list.classList.add("list-flush"); }
		if (this.gap) { list.classList.add(`spaced-list--${this.gap}`); }

		this.appendChild(list);

		this.toggleVisibility();
	}
}